const msgs = {
  'not-enough-data': 'Not enough data',
  'unknown-error': 'Unknown error',
  'not-permissions': "You don't have enough permissions for this action",

  'login-field-empty':  'Please enter your login!',
  'login-field-no-email': 'Your login should be an email!',
  'password-field-empty': 'Please enter your password!',
  'password-field-too-short': 'Your password is too short!',
  'token-empty': 'You looks like a robot!',
  'empty-recaptcha': 'Faild to generate ReCaptcha',

  'signin-failed': 'Signing in failed',
  'signin-wrong-data': 'Invalid username or password',
  'signout-failed': 'Signing out failed',

  'load-orders-filed': 'Failed to load orders',
  'order-load-failed': 'Failed to load the order',
  'empty-order-id': 'Order not found',

  'trackinginfo-no-carrier': 'Please choose a shipper!',
  'trackinginfo-short-carrier': 'The shipper name is too short!',
  'trackinginfo-no-tracking': 'Please enter a tracking number!',
  'trackinginfo-short-tracking': 'The tracking number is too short!',
  'failed-to-add-tracking-info': 'Failed to save the tracking information.',
  'success-tracking-products-adding': 'Tracking information saved for all products',
  'success-tracking-product-adding': 'Tracking information saved',
};

export const msg = (key: keyof typeof msgs, options?: Record<string, string | number>): string =>
  options
    ? Object.entries(options).reduce((acc, [key, value]) =>
      acc.replaceAll(`{{${key}}}`, String(value)), msgs[key])
    : msgs[key];
